import { render, staticRenderFns } from "./AuthCardEmail.vue?vue&type=template&id=25c27d8c&scoped=true&"
import script from "./AuthCardEmail.vue?vue&type=script&lang=js&"
export * from "./AuthCardEmail.vue?vue&type=script&lang=js&"
import style0 from "./AuthCardEmail.vue?vue&type=style&index=0&id=25c27d8c&scoped=true&lang=css&"
import style1 from "./AuthCardEmail.vue?vue&type=style&index=1&id=25c27d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c27d8c",
  null
  
)

export default component.exports